import React from 'react';
import { Coins, Globe, Wallet, Sprout, Users, ArrowUpRight, CheckCircle2 } from 'lucide-react';
import PageHero from '../components/PageHero';
import CTASection from '../components/CTASection';
import { OFFER_STATS, IMAGES } from '../data/mock';
import { useConnect } from '../context/ConnectContext';
import useReveal from '../hooks/useReveal';

const iconMap = { Coins, Globe, Wallet };

export default function WhatWeOffer() {
  const { openConnect } = useConnect();
  useReveal([]);

  return (
    <div>
      <PageHero
        eyebrow="What we offer"
        lead="Worldwide"
        title="Investment Options"
        subtitle="Farmway enables easy access to global agricultural project investments through a simple, user-friendly and comprehensive fintech platform."
        image={IMAGES.fieldsGold}
      />

      {/* STATS */}
      <section className="py-24">
        <div className="container-fw">
          <div className="grid gap-6 md:grid-cols-3">
            {OFFER_STATS.map((s, i) => {
              const Icon = iconMap[s.icon];
              return (
                <div key={s.label} className="reveal rounded-2xl border border-white/10 bg-farmway-green-mid/40 p-8 text-center" data-delay={i * 100}>
                  <div className="mx-auto grid h-16 w-16 place-items-center rounded-2xl bg-farmway-gold/15 text-farmway-gold">
                    <Icon className="h-8 w-8" />
                  </div>
                  <p className="mt-6 font-display text-3xl font-black text-farmway-cream">{s.value}</p>
                  <p className="mt-2 text-sm text-farmway-cream/60">{s.label}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* MISSION */}
      <section className="pb-24">
        <div className="container-fw grid items-center gap-14 lg:grid-cols-2">
          <div className="reveal relative overflow-hidden rounded-3xl">
            <img src={IMAGES.appleOrchard} alt="Orchard" className="h-[440px] w-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-farmway-green-dark/60 to-transparent" />
          </div>
          <div className="reveal" data-delay="120">
            <span className="eyebrow">Democratizing access</span>
            <h2 className="mt-4 display-xl text-4xl text-farmway-cream sm:text-5xl">Fractional investment, for everyone</h2>
            <p className="mt-5 text-farmway-cream/75">
              Support the growth and development of sustainable farming and agribusinesses by enabling
              and democratizing fractional investment from anyone and anywhere.
            </p>
            <ul className="mt-7 space-y-4">
              {[
                'Curated 1P & 3P investment opportunities',
                'End-to-end on-ground operations, in-house',
                'Transparent, direct ownership of real assets',
              ].map((t) => (
                <li key={t} className="flex items-start gap-3 text-farmway-cream/85">
                  <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-farmway-leaf" />
                  <span>{t}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      {/* ADVISORY */}
      <section className="relative overflow-hidden bg-farmway-green-dark py-24">
        <div className="container-fw grid gap-10 lg:grid-cols-2 lg:items-center">
          <div className="reveal">
            <div className="grid h-14 w-14 place-items-center rounded-2xl bg-farmway-gold/15 text-farmway-gold">
              <Users className="h-7 w-7" />
            </div>
            <h2 className="mt-6 display-xl text-3xl text-farmway-cream sm:text-4xl">Advisory &amp; Operations</h2>
          </div>
          <p className="reveal text-lg leading-relaxed text-farmway-cream/75" data-delay="120">
            Farmway&apos;s in-house Advisory and Operations are responsible not only for the
            identification, curation and selection of investment opportunities, for both first-party
            and third-party, but also for the end-to-end, on-the-ground operations of every
            agricultural project.
          </p>
        </div>
      </section>

      <CTASection />
    </div>
  );
}
